import { call, put, takeEvery } from "redux-saga/effects";

//constant file
import Constant, { EditProfileMenu,FilterOptions } from '../../Constants/constants'
import RouteSegment, { RouteHelper, RoutePaths } from '../../Routes/RouteSegment'
 

// Login Redux States
import { CHANGE_MOBILE_NO, COMMUNITY_SITE_DETAIL, GET_BASIC_DATA, GET_BASIC_DATA_SUCCESS, LOGIN_FOR_AKHAYATRITIYA, LOGIN_FROM_ADMIN_PARTIAL_USER, 
  LOGIN_FROM_ADMIN_USER, LOGIN_FROM_EMAIL_USER, LOGIN_FROM_OFFLINE, LOGIN_FROM_SMS_USER, LOGIN_FROM_OTP_USER, LOGIN_USER, MOBILE_VERIFICATION, MOBILE_VERIFICATION_FRESH, MORE_LINK_CONTENT,
   OTP_VALIDATION, REQUEST_AGAIN, RESET_PASSWORD, SEND_OTP, SITE_MAP ,LOGIN_FROM_FEEDBACK,LOGIN_FROM_ADMIN_UPLOAD_PARTIAL_USER ,COMMUNITYSITE_CONTENT} from "./ActionTypes";
import { apiError, loginSuccess, getBasicDataSuccess, resetPasswordApiError, resetPasswordSuccess, sendOTPSuccess, sendOTPApiError, OTPValidationSuccess, 
  OTPValidationApiError, mobileVerificationSuccess, mobileVerificationApiError, requestAgainSuccess, requestAgainApiError, mobileVerificationFreshApiError, 
  mobileVerificationFreshSuccess, changeMobileNoSuccess, changeMobileNoapiError, moreLinkContentSuccess, moreLinkContentApiError, loginFromAdminSuccess,
   loginFromAdminApiError, communitySiteDetailSuccess, communitySiteDetailApiError, loginFromEmailSuccess, loginFromEmailApiError, loginForAkhayatritiyaSuccess,
    loginForAkhayatritiyaApiError, loginFromAdminPartialUser, loginFromAdminPartialSuccess, loginFromAdminPartialApiError, siteMapDetailSuccess, siteMapDetailApiError,
     loginFromOfflineSuccess, loginFromOfflineError, loginForViewProfileSuccess, loginForViewProfileError
  ,loginFromFeedBackSuccess,loginFromFeedBackError, loginfromuploadpartialSuccess, loginfromuploadpartialError ,communitySiteContentSuccess,communitySiteContentError} from "./Action";
import { Login, ResetPassword, BasicData, SendOTP, OTPValidation, MobileVerification, RequestAgain, MobileVerificationFresh, ChangeMobileNo,
   MoreLinkContent, AdminLogin, SMSLogin, EmailLogin, CommunitySiteData, AkhayatritiyaLogin, PartialAdminLogin, SiteMapData, Update_Notification_Status,
    CMS_Login, CMS_Login_via, offlineProfileLogin, viewProfileLogin,Feedback_Resolved_Form, UploadPartialAdminLogin ,CommunityPayment ,CommunitySiteContentApi, LoginV4, LoginFromOtp} from '../../Helpers/api_helpers'
import { SMS_LOGIN } from "../../Helpers/EndPoints";
import Constants from "../../Constants/constants";
import RouteSegments from "../../Routes/RouteSegment";
import { addPoint } from "../KalyanRewards/Action";
import { getDeviceInfo } from "../../Components/Kalyanlite/utils";
import i18n from "../../i18n";
import { Navigate, useNavigate } from "react-router-dom";
import { use } from "react";
import EndPoints from "../../Constants/EndPoints";
import config from "../../config";
import { POST } from "../../Services/api_services";
import { SUCCESS_STORY_FORM } from "./ActionTypes";
import { successstoryformSuccess, successstoryformError } from "./Action";
import { SuccessStoryLogin } from '../../Helpers/api_helpers';
import {
  buildLoginV4RequestBody,
  getLoginDataNextPage,
  hasLoginExpiredPopup,
  isLoginCompleteSuccess,
  isProfileDeletedStatus,
  persistLoginSessionForHandoff,
  redirectToV5Registration,
  resolvePostLoginPath,
  shouldHandoffToV5ForNextPage,
  shouldHandleAsLoginError,
  shouldRedirectToV5Registration,
  resolveLoginV5HandoffData,
  shouldResolveChildrenStatusNextPage,
  shouldResolveDenominationSelectionNextPage,
  shouldResolveGothramDetailsNextPage,
  storeV5LoginNextPage,
  getSelectedVersion,
  usesLiteExperience,
} from "../../Utils/loginV4Redirect";

const getLoginRedirection = (redirection) => {
  const value = String(redirection ?? "").trim().toLowerCase();

  if (value === "selfpaymicrosite") {
    return RouteSegments.SELF_PAY;
  }

  if (value === "photo") {
    return RouteHelper.getEditProfileUrl(EditProfileMenu[2].urlPath);
  }

  if (value === "matches") {
    return RouteSegments.MATCH_LITE;
  }

  return null;
};

const getProvidedSelfPayId = (user) => {
  const currentSearchParams =
    typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;
  const selfPayId =
    user?.selfPayId ??
    user?.selfpayId ??
    user?.selfpayid ??
    user?.selfPayData?.selfpayId ??
    currentSearchParams?.get("selfPayId") ??
    currentSearchParams?.get("selfpayId") ??
    currentSearchParams?.get("selfpayid");
  const value = String(selfPayId ?? "").trim();

  if (!value || value === "undefined" || value === "null") {
    return null;
  }

  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? value : numericValue;
};

const getProvidedDiscountCode = (user) => {
  const currentSearchParams =
    typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;
  const discountCode =
    user?.discountCode ??
    currentSearchParams?.get("discountCode");
  const value = String(discountCode ?? "").trim();

  if (!value || value === "undefined" || value === "null") {
    return null;
  }

  return value;
};

const getProvidedDiscountParam = (user) => {
  const currentSearchParams =
    typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;
  const discount = user?.discount ?? currentSearchParams?.get("discount");
  const value = String(discount ?? "").trim();

  if (!value || value === "undefined" || value === "null") {
    return null;
  }

  return value;
};

const getProvidedExpiryDate = (user) => {
  const currentSearchParams =
    typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;
  const expiryDate = user?.expiryDate ?? currentSearchParams?.get("expiryDate");
  const value = String(expiryDate ?? "").trim();

  if (!value || value === "undefined" || value === "null") {
    return null;
  }

  return value;
};

function* trackSelfPayClick(user, response) {
  const selfPayId = getProvidedSelfPayId(user);

  if (!selfPayId) {
    return;
  }

  try {
    yield call(POST, `${config.api.API_URL}${EndPoints.selfpaytrackingUrl()}`, {
      email: response?.data?.data?.userName ?? user?.email,
      userId: response?.data?.data?.userId,
      selfPayId,
      isClicked: true,
      loginFrom:
        user?.loginFrom ??
        localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice) ??
        getDeviceInfo(),
    });
  } catch {
    // Login success flow should not fail because self-pay tracking failed.
  }
}

const savePendingSelfPayPhotoFulfillment = (user, response) => {
  const selfPayId = getProvidedSelfPayId(user);

  if (!selfPayId) {
    return;
  }

  try {
    localStorage.setItem("selfPayPhotoFulfillment", JSON.stringify({
      email: response?.data?.data?.userName ?? user?.email,
      userId: response?.data?.data?.userId,
      selfPayId,
      loginFrom:
        user?.loginFrom ??
        localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice) ??
        getDeviceInfo(),
    }));
  } catch {
    // Photo redirection should not fail because tracking data could not be stored.
  }
};

const savePendingSelfPayMatchesFulfillment = (user, response) => {
  const selfPayId = getProvidedSelfPayId(user);

  if (!selfPayId) {
    return;
  }

  try {
    localStorage.setItem("selfPayMatchesFulfillment", JSON.stringify({
      email: response?.data?.data?.userName ?? user?.email,
      userId: response?.data?.data?.userId,
      selfPayId,
      loginFrom:
        user?.loginFrom ??
        localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice) ??
        getDeviceInfo(),
    }));
  } catch {
    // Matches redirection should not fail because tracking data could not be stored.
  }
};

const savePendingSelfPayPaymentFulfillment = (user, response) => {
  const selfPayId = getProvidedSelfPayId(user);
  const discountCode = getProvidedDiscountParam(user);
  const expiryDate = getProvidedExpiryDate(user);

  if (!selfPayId) {
    return;
  }

  try {
    if (discountCode) {
      localStorage.setItem("discountCode", discountCode);
    }
    if (expiryDate) {
      localStorage.setItem("expiryDate", expiryDate);
    } else {
      localStorage.removeItem("expiryDate");
    }
    localStorage.setItem("selfPayId", selfPayId);
    localStorage.setItem("selfpayId", selfPayId);
    localStorage.setItem("selfPayPaymentFulfillment", JSON.stringify({
      email: response?.data?.data?.userName ?? user?.email,
      userId: response?.data?.data?.userId,
      selfPayId,
      loginFrom:
        user?.loginFrom ??
        localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice) ??
        getDeviceInfo(),
    }));
  } catch {
    // Self-pay payment redirection should not fail because tracking data could not be stored.
  }
};

function* loginUser({ payload: { user, history } }) {
  const isMobileSite = localStorage.getItem(Constant.loginLocalStorageKeys.loginDevice) === "Mobile Site";

  const isCheckboxTrue = localStorage.getItem(Constants.loginLocalStorageKeys.isCheckbox) === "true";
  const isCheckedTrue = localStorage.getItem(Constants.loginLocalStorageKeys.isChecked) === "true";
  const isFromNotLoginOrNotPresent = localStorage.getItem(Constants.loginLocalStorageKeys.From) == "sign in";

  const rememberMe =
    isMobileSite && localStorage.getItem(Constants.loginLocalStorageKeys.isFrom) == "login" && isCheckboxTrue ? { remember_me: true } :
      isMobileSite && localStorage.getItem(Constants.loginLocalStorageKeys.isFrom) == "sign in" && isCheckedTrue ? { remember_me: true } :
        { remember_me: false };

  const device =
    isMobileSite && localStorage.getItem(Constants.loginLocalStorageKeys.isFrom) == "login" && isCheckboxTrue ? { device: "yes" } :
      isMobileSite && localStorage.getItem(Constants.loginLocalStorageKeys.isFrom) == "sign in" && isCheckedTrue ? { device: "yes" } :
        { device: "no" };
  try {
    const deviceFlag = device.device ?? "no";
    const response = yield call(LoginV4, {
      ...buildLoginV4RequestBody(
        {
          name: user.name,
          password: user.password,
          familynumber: user.familynumber,
          offlinepack: user.offlinepack,
          otp: user.otp,
          webKey: localStorage.getItem(Constant.loginLocalStorageKeys.fcmToken),
        },
        deviceFlag
      ),
    });
    if (response.data.status === "Success") {
      const loginData = response.data.data;
      const token = response?.headers?.authorization;

      if (
        hasLoginExpiredPopup(loginData) ||
        isProfileDeletedStatus(loginData) ||
        shouldHandleAsLoginError(loginData)
      ) {
        yield put(loginSuccess(response));
        return;
      }

      if (shouldRedirectToV5Registration(loginData)) {
        const handoffLoginData = yield call(
          resolveLoginV5HandoffData,
          loginData
        );
        persistLoginSessionForHandoff(handoffLoginData, token);
        redirectToV5Registration(handoffLoginData, token);
        yield put(loginSuccess(response));
        return;
      }

      const isLegacySuccess = loginData?.status === "SUCCESS";
      if (isLoginCompleteSuccess(loginData) || isLegacySuccess) {
        const otpSentVia = response?.data?.data?.otpSentVia;
        if (otpSentVia) localStorage.setItem(Constants.loginLocalStorageKeys.otpSentVia, otpSentVia);
        else localStorage.removeItem(Constants.loginLocalStorageKeys.otpSentVia);

        localStorage.setItem(Constant.loginLocalStorageKeys.loginFrom, new URL(window.location.href).pathname + new URL(window.location.href).search)
        localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)

        // if(localStorage.getItem("checkbox") == "true"){
        localStorage.setItem("loggedIn", true)
        localStorage.setItem("pw", user.password) //pw
        // }

        const sessionCookie = response.headers["set-cookie"];


        localStorage.setItem(Constant.loginLocalStorageKeys.session, sessionCookie);


        const token = response?.headers['authorization']; // Extract token

        localStorage.setItem(Constant.loginLocalStorageKeys.accessToken, token);

        const reg = new RegExp('^[0-9]+$');
        if (usesLiteExperience(getSelectedVersion(response.data.data))) {
          localStorage.setItem("isV3User", true)
    
        let cms_response;

        try {
          if (user.otp) {
            // 🔹 Login via OTP → use CMS_Login_via with JWT
            cms_response = yield call(CMS_Login_via, {
              jwt_token: user.jwt ? user.jwt : token
            });
          } else {
            // 🔹 Normal login → use CMS_Login with email/password
            cms_response = yield call(CMS_Login, {
              [reg.test(user.name) ? "mobile_number" : "email"]: user.name ?? null,
              password: user.password,
              ...(isMobileSite && { device: "Mobile Site" }),
              ...rememberMe
            });
          }

          if (cms_response?.data) {
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLogin,
              String(cms_response?.data?.access_token) ?? "OLD"
            );
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLoginId,
              String(cms_response?.data?.id) ?? ""
            );
          }
        } catch (cmsError) {
          // Chat login failure should not block app login redirect
          console.error("CMS login failed:", cmsError);
        }
      
        }
        yield put(loginSuccess(response));
        localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true) //is loggedin
        localStorage.setItem(Constant.loginLocalStorageKeys.loginName, response.data.data.userName ?? "") //username
        localStorage.setItem(Constant.loginLocalStorageKeys.loginEmail, response.data.data.userName ?? "")
        localStorage.setItem(Constant.loginLocalStorageKeys.loginId, response.data.data.userId) //userid
        localStorage.setItem("kmcareunreadmsg", true) 

        localStorage.removeItem("profiledot", false);
        localStorage.setItem(Constant.loginLocalStorageKeys.loginCheckForRquest,'loginCheckForReq')
        localStorage.setItem(Constant.loginLocalStorageKeys.uploadFrom, response.data.data?.uploadFrom)
        
        //for vernacular
        i18n.changeLanguage(response.data.data?.vernacularCode ?? "en")
        localStorage.setItem(Constant.loginLocalStorageKeys.vernacularCode, response.data.data.vernacularCode ?? "en")


        // if (response.data.data?.paymentToken) {
        //   window.location.href = response.data.data?.paymentToken
        // } 
         if (response.data.data.nextPage == "Redirect") {
          // history(`${response.data.data.redirect}`)
          window.location.href = "https://" + response.data.data.redirect
        } else if (response.data.data.nextPage == "communityPayment") {
          history(RouteSegment.COMMUNITY_PAYMENT); 

            sessionStorage.setItem(Constants.loginLocalStorageKeys.communitypaymentpage,"true")


            try {
              const communityPaymentResponse = yield call(CommunityPayment, {
                loginFrom: localStorage.getItem(Constant.loginLocalStorageKeys.loginDevice),
              });
          
              if (communityPaymentResponse?.data?.status === "Success") {
                const paymentToken = communityPaymentResponse.data?.data?.paymentToken;
                   console.log(communityPaymentResponse,"communityPaymentResponse");

                // Optionally store anything else if needed
                localStorage.setItem(Constants.loginLocalStorageKeys.paymentToken, paymentToken);
                localStorage.setItem('paymentTokens', paymentToken);

              } else {
                // Handle failure if needed
                yield put(apiError(communityPaymentResponse));
              }
            } catch (error) {
              yield put(apiError(error));
            }
        }
        else if (response.data.data.nextPage === "phoneNumberEdit") {
          localStorage.setItem("phoneNumberEdit", true)
          history(`${RouteHelper.getEditProfileUrl(EditProfileMenu[5].urlPath)}`)
        } else if (response.data.data.nextPage === "phoneNumberEdit") {
          localStorage.setItem("phoneNumberEdit", true)
          history(`${RouteHelper.getEditProfileUrl(EditProfileMenu[5].urlPath)}`)
        } 
         else if (response.data.data.nextPage === "afterRegistration"){
          localStorage.setItem(Constants.loginLocalStorageKeys.allowAfterRegPage, "true")
          localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, RouteSegments.AFTER_REGISTRATION)
          history(RouteSegments.AFTER_REGISTRATION)
        }

        
        else if (user.profileid && user.action == "view") {
          if (usesLiteExperience(response.data.data?.selectedversion)) {

            history(RouteSegments.MATCH_CONVERSATIONS_LITE, {
              state: {
                isFrom: "login",
                id: user.profileid,
                isFromChat: false,
                from: "search"
              }
            })
          } else {
            history(RouteHelper.getProfileUrl, { state: { id: user.profileid.replace(/KM/g, "") } })
          }
        }
       
        else {
          const nextPage = getLoginDataNextPage(response.data.data);
          const normalizedNext = `${nextPage}`.trim().toLowerCase();
          if (shouldHandoffToV5ForNextPage(nextPage)) {
            const handoffLoginData = yield call(
              resolveLoginV5HandoffData,
              response.data.data
            );
            persistLoginSessionForHandoff(handoffLoginData, token);
            storeV5LoginNextPage(nextPage);
            redirectToV5Registration(handoffLoginData, token, {
              sameTab: true,
              extraParams: {
                nextPage,
              },
            });
            return;
          }
          if (shouldResolveChildrenStatusNextPage(nextPage)) {
            const handoffLoginData = yield call(
              resolveLoginV5HandoffData,
              response.data.data
            );
            persistLoginSessionForHandoff(handoffLoginData, token);
            storeV5LoginNextPage(nextPage);
            redirectToV5Registration(handoffLoginData, token, {
              sameTab: true,
              extraParams: {
                nextPage,
              },
            });
            return;
          }
          if (shouldResolveDenominationSelectionNextPage(nextPage)) {
            const handoffLoginData = yield call(
              resolveLoginV5HandoffData,
              response.data.data
            );
            persistLoginSessionForHandoff(handoffLoginData, token);
            storeV5LoginNextPage(nextPage);
            redirectToV5Registration(handoffLoginData, token, {
              sameTab: true,
              extraParams: {
                nextPage,
              },
            });
            return;
          }
          if (shouldResolveGothramDetailsNextPage(nextPage)) {
            const handoffLoginData = yield call(
              resolveLoginV5HandoffData,
              response.data.data
            );
            persistLoginSessionForHandoff(handoffLoginData, token);
            storeV5LoginNextPage(nextPage);
            redirectToV5Registration(handoffLoginData, token, {
              sameTab: true,
              extraParams: {
                nextPage,
              },
            });
            return;
          }
          if (
            !nextPage ||
            nextPage === "/" ||
            normalizedNext === "signin"
          ) {
            history(
              resolvePostLoginPath(
                response.data.data,
                getSelectedVersion(response.data.data)
              )
            );
          } else {
            const path = resolvePostLoginPath(
              response.data.data,
              getSelectedVersion(response.data.data)
            );
            localStorage.setItem(
              Constant.loginLocalStorageKeys.loginCurrentPage,
              path
            );
            history(path);
          }
        }
      }
      else {
        yield put(loginSuccess(response));
      }
    }
    else {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(apiError(response));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* changeMobileNo({ payload: { user } }) {
  try {
    const response = yield call(ChangeMobileNo, {
      userId: localStorage.getItem(Constant.loginLocalStorageKeys.loginId),
      email: localStorage.getItem(Constant.loginLocalStorageKeys.loginName) == '' ? null : localStorage.getItem(Constant.loginLocalStorageKeys.loginName),
      changeNumberFlag: "mobile",
      isdcode: user.ISDCode,
      mobileNumber: user.MobileNumber,
      loginFrom : getDeviceInfo()
    });
    if (response.data.status === "Success") {
       if( response.data.data.status === "SUCCESS") {
        localStorage.setItem("isverifybuttondisable", "false");
      }
      yield put(changeMobileNoSuccess(response));
    } else {
      yield put(changeMobileNoapiError(response));
    }
  } catch (error) {
    yield put(sendOTPApiError(error));
  }
}

function* sendOTP({ payload: { user } }) {
  try {
    const response = yield call(SendOTP, {
      userId: localStorage.getItem(Constant.loginLocalStorageKeys.loginId),
      email: localStorage.getItem(Constant.loginLocalStorageKeys.loginName) == '' ? null : localStorage.getItem(Constant.loginLocalStorageKeys.loginName),
      loginFrom: localStorage.getItem(Constant.loginLocalStorageKeys.loginDevice),
      isdcode: user[0].isdcode,
      mobileNumber: user[0].mobileNo
    });
    if (response.data.data.status === "SUCCESS") {
      yield put(sendOTPSuccess(response));
      if (response.data.data.nextPage == "basicdata") {
      }
    } else {
      yield put(sendOTPApiError(response));
    }
  } catch (error) {
    yield put(sendOTPApiError(error));
  }
}

function* OTPValidationCall({ payload: { user, requestData, phone, history, formik } }) {
  // function* resetPassword({ payload: {id, user, history } }) {
  try {
    const response = yield call(OTPValidation, {
      userId: user,
      otp: requestData.pin,
      mobileNumber: phone
    });
    if (response?.data?.status === "Success") {
      if (response?.data?.data?.status === "FAILURE") {
        formik.setFieldError("pin", response?.data?.data?.statusMessage)
        yield put(OTPValidationSuccess(response));
      }
      else {
        const authToken = response?.headers?.authorization;
        console.log("authToken", authToken);
        if (authToken) {
          localStorage.setItem("forgotPasswordToken", authToken);
        }
        yield put(OTPValidationSuccess(response));
        history(RouteSegment?.FORGOT_PASSWORD)
      }
    } else {
      yield put(OTPValidationApiError(response));
    }
  } catch (error) {
    yield put(OTPValidationApiError(error));
  }
}

function* mobileVerificationCall({ payload: { user, requestData, history, setIsSubmitting } }) {

  const isCommunitySite = localStorage.getItem(Constants.loginLocalStorageKeys.isCommunitySite);

  try {
    const response = yield call(MobileVerification, {
      email: localStorage.getItem(Constant.loginLocalStorageKeys.loginName) == '' ? null : localStorage.getItem(Constant.loginLocalStorageKeys.loginName),
      userId: localStorage.getItem(Constant.loginLocalStorageKeys.loginId),
      loginFrom: localStorage.getItem(Constant.loginLocalStorageKeys.loginDevice),
      otp: user.PINNumber,
    });
    if (response.data.status === "Success") {
      yield put(mobileVerificationSuccess(response));
      if (response.data.data.status === "SUCCESS") {



        // localStorage.setItem(Constant.loginLocalStorageKeys.loginFrom,new URL(window.location.href.hostname))
        localStorage.setItem(Constant.loginLocalStorageKeys.loginFrom, new URL(window.location.href).pathname + new URL(window.location.href).search)
        localStorage.setItem(Constant.loginLocalStorageKeys.isFirstLogin, "true")
        localStorage.setItem(Constant.loginLocalStorageKeys.verificationLoginFrom, response.data.data.loginFrom)
        localStorage.setItem(Constants.loginLocalStorageKeys.paymentData, response.data.data?.paymentData)
        sessionStorage.setItem('isFromMobileVerifyPage', 'true')
        if (usesLiteExperience(response.data.data?.selectedversion)) {
          localStorage.setItem("isV3User", true)

          const token = response?.headers?.['authorization']; // Extract token

          if (token) {
            localStorage.setItem(Constants.loginLocalStorageKeys.accessToken, token); // Store token
          }
          
          const storedToken = localStorage.getItem(Constants.loginLocalStorageKeys.accessToken); // Retrieve token

          

          const cms_response = yield call(CMS_Login_via, {
            
            jwt_token:  user.jwt? user.jwt : storedToken
            // userId: localStorage.getItem(Constant.loginLocalStorageKeys.loginId),
          });

          if (cms_response.data) {
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLogin,
              String(cms_response?.data?.access_token) ?? "OLD"
            );
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLoginId,
              String(cms_response?.data?.id) ?? ""
            );
          }
          history(RouteSegment.MATCH_LITE, { replace: true });
        }


        //to allow navigation into after reg page
        localStorage.setItem(Constants.loginLocalStorageKeys.allowAfterRegPage, "true")
        localStorage.removeItem("preferenceFlowState")
        localStorage.removeItem("parentsNumberFlowState")
        localStorage.removeItem("isOriginalImageUploaded")

        // if(response.data.data?.paymentData){
        //   localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage, RouteSegment.COMMUNITY_PAYMENT)
        //   localStorage.setItem(Constants.loginLocalStorageKeys.paymentData, response.data.data?.paymentData)
        // }
        // else{
        //   localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage, RouteSegment.COMMUNITY_PAYMENT)
        // }
        if (isCommunitySite) {
        if (response?.data?.data?.paymentData) {
          if (response.data.data?.nextPage === "/communityPayment") {
            history(RouteSegment.COMMUNITY_PAYMENT);
            localStorage.setItem(Constants.loginLocalStorageKeys.paymentData, response.data.data?.paymentData);
            localStorage.setItem(Constants.loginLocalStorageKeys.paymentToken, response.data.data?.paymentData?.paymentToken);
            sessionStorage.setItem(Constants.loginLocalStorageKeys.communitypaymentpage, "true");
          } 
          else if (response?.data?.data?.loginFrom === "partial") {
            history(RouteSegment.COMMUNITY_PAYMENT);
            localStorage.setItem(Constants.loginLocalStorageKeys.loginfrompartial, response?.data?.data?.loginFrom);
            localStorage.setItem(Constants.loginLocalStorageKeys.paymentData, response.data.data?.paymentData);
            localStorage.setItem(Constants.loginLocalStorageKeys.paymentToken, response.data.data?.paymentData?.paymentToken);
            sessionStorage.setItem(Constants.loginLocalStorageKeys.communitypaymentpage, "true");
          }else {
          history(RouteSegment.COMMUNITY_PAYMENT);
            localStorage.setItem(Constants.loginLocalStorageKeys.loginfrompartial, response?.data?.data?.loginFrom);
            localStorage.setItem(Constants.loginLocalStorageKeys.paymentData, response.data.data?.paymentData);
            localStorage.setItem(Constants.loginLocalStorageKeys.paymentToken, response.data.data?.paymentData?.paymentToken);
            sessionStorage.setItem(Constants.loginLocalStorageKeys.communitypaymentpage, "true");
          }
        } else {
          history(RouteSegment.AFTER_REGISTRATION);
          localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage, RouteSegment.AFTER_REGISTRATION);
        }
      } else {
        history(RouteSegment.AFTER_REGISTRATION);
        localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage, RouteSegment.AFTER_REGISTRATION);
      }


      }
      else if(response.data.data.status === "FAILURE" && response.data.data.statusMessage === "Too many wrong attempts. Try again later.") {
        localStorage.setItem("isverifybuttondisable", "true");
      }
      if (setIsSubmitting) {
        setIsSubmitting(false)
      }
    } else {
      if (setIsSubmitting) {
        setIsSubmitting(false)
      }
      yield put(mobileVerificationApiError(response));
    }
  } catch (error) {
    yield put(mobileVerificationApiError(error));
  }
}

function* mobileVerificationFreshCall({ payload: { user, requestData, history } }) {
  try {
    const response = yield call(MobileVerificationFresh, {
      email: localStorage.getItem(Constant.loginLocalStorageKeys.loginName) == '' ? null : localStorage.getItem(Constant.loginLocalStorageKeys.loginName),
      userId: localStorage.getItem(Constant.loginLocalStorageKeys.loginId),
      loginFrom : getDeviceInfo()
    });
    if (response.data.status === "Success") {
      const otpSentVia = response?.data?.data?.otpSentVia;
      if (otpSentVia) localStorage.setItem(Constants.loginLocalStorageKeys.otpSentVia, otpSentVia);
      else localStorage.removeItem(Constants.loginLocalStorageKeys.otpSentVia);

      yield put(mobileVerificationFreshSuccess(response));
         if( response.data.data.status === "SUCCESS") {
        localStorage.setItem("isverifybuttondisable", "false");
        sessionStorage.setItem('isFromMobileVerifyPage', 'true')
      }
      // history(RouteSegment.DASHBOARD);
    } else {
      yield put(mobileVerificationFreshApiError(response));
    }
  } catch (error) {
    yield put(mobileVerificationFreshApiError(error));
  }
}

function* requestAgainCall({ payload: { user } }) {
  try {
    const response = yield call(RequestAgain, {
      email: localStorage.getItem(Constant.loginLocalStorageKeys.loginName) == '' ? null : localStorage.getItem(Constant.loginLocalStorageKeys.loginName),
      userId: localStorage.getItem(Constant.loginLocalStorageKeys.loginId),
      loginFrom : getDeviceInfo()
    });
    if (response.data.status === "Success") {
      if( response.data.data.status === "SUCCESS") {
        localStorage.setItem("isverifybuttondisable", "false");
      }
      yield put(requestAgainSuccess(response));
    } else {
      yield put(requestAgainApiError(response));
    }
  } catch (error) {
    yield put(requestAgainApiError(error));
  }
}

function* getBasicData({ payload: { userId } }) {
  try {
    const responseData = yield call(BasicData, {
      "userId": userId,
      "loginFrom": localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
      "registerFrom": localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),

    });
    if (responseData.data.data.status === "SUCCESS") {
      yield put(getBasicDataSuccess(responseData));
    }
  }
  catch (error) {
    yield put(apiError(error));
  }
}

//reset password
function* resetPassword({ payload: { user, id, history } }) {
  try {
    const token = localStorage.getItem("forgotPasswordToken");

console.log("Token in saga:", token);
    const response = yield call(ResetPassword, {
      userId: id,
      password: user.confirmPassword
    },
      {
        headers: { Authorization: token }
      }
    );
    if (response.data.status === "Success") {
      if (response.data.data.status === "SUCCESS") {
        yield put(resetPasswordSuccess(response));
        localStorage.removeItem("forgotPasswordToken");
        history(RouteSegment?.HOME)
      } else {
        yield put(resetPasswordApiError(response));
      }
    } else {
      yield put(resetPasswordApiError(response));
         if (response.data?.statusCode === 401) {
        history(RouteSegment?.HOME); // redirect on unauthorized
      }
    }
  } catch (error) {
    yield put(resetPasswordApiError(error));
  }
}

//more link content 
function* moreLinkContent({ payload: { user } }) {
  try {
    const response = yield call(MoreLinkContent);
    if (response.data.status === "Success") {
      yield put(moreLinkContentSuccess(response));
    } else {
      yield put(moreLinkContentApiError(response));
    }
  } catch (error) {
    yield put(moreLinkContentApiError(error));
  }
}

//login from otp link (/loginfromotp → /v4/loginfromotp)
function* loginFromOtpUser({ payload: { user, history } }) {
  try {
    const loginFrom =
      user.loginFrom ?? user.loginfrom ?? getDeviceInfo();
    const response = yield call(LoginFromOtp, {
      smslogid: user.smslogid ?? user.smslogId,
      loginfrom: loginFrom,
      jwt: user.jwt,
    });

    if (response.data.status !== "Success") {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true);
      yield put(loginFromAdminApiError(response));
      return;
    }

    const loginData = response.data.data;

    if (loginData?.popup) {
      sessionStorage.setItem("loginFromOtp", JSON.stringify(loginData.popup));
    }

    if (
      hasLoginExpiredPopup(loginData) ||
      isProfileDeletedStatus(loginData) ||
      shouldHandleAsLoginError(loginData)
    ) {
      yield put(loginFromAdminSuccess(response));
      return;
    }

    if (shouldRedirectToV5Registration(loginData)) {
      const token = response?.headers?.authorization;
      const handoffLoginData = yield call(
        resolveLoginV5HandoffData,
        loginData
      );
      persistLoginSessionForHandoff(handoffLoginData, token);
      redirectToV5Registration(handoffLoginData, token, { sameTab: true });
      yield put(loginFromAdminSuccess(response));
      return;
    }

    if (loginData?.userId) {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true);
      localStorage.setItem(Constant.loginLocalStorageKeys.loginFrom, window.location.href);

      const token = response?.headers?.authorization;
      if (token) {
        localStorage.setItem(Constant.loginLocalStorageKeys.accessToken, token);
      }

      if (usesLiteExperience(loginData?.selectedversion)) {
        localStorage.setItem("isV3User", true);
        const cms_response = yield call(CMS_Login_via, {
          jwt_token: user.jwt ? user.jwt : token,
        });
        if (cms_response?.data) {
          localStorage.setItem(
            Constant.loginLocalStorageKeys.chatLogin,
            String(cms_response?.data?.access_token) ?? "OLD"
          );
          localStorage.setItem(
            Constant.loginLocalStorageKeys.chatLoginId,
            String(cms_response?.data?.id) ?? ""
          );
        }
      }

      localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true);
      localStorage.setItem(Constant.loginLocalStorageKeys.loginName, loginData.userName ?? "");
      localStorage.setItem(Constant.loginLocalStorageKeys.loginEmail, loginData.userName ?? "");
      localStorage.setItem(Constant.loginLocalStorageKeys.loginId, loginData.userId);
      localStorage.setItem(Constant.loginLocalStorageKeys.loginCheckForRquest, "loginCheckForReq");
      i18n.changeLanguage(loginData?.vernacularCode ?? "en");
      localStorage.setItem(
        Constant.loginLocalStorageKeys.vernacularCode,
        loginData.vernacularCode ?? "en"
      );

      yield put(loginFromAdminSuccess(response));

      const nextPage = getLoginDataNextPage(loginData);
      const normalizedNext = `${nextPage}`.trim().toLowerCase();
      if (shouldHandoffToV5ForNextPage(nextPage)) {
        const token = response?.headers?.authorization;
        const handoffLoginData = yield call(
          resolveLoginV5HandoffData,
          loginData
        );
        persistLoginSessionForHandoff(handoffLoginData, token);
        storeV5LoginNextPage(nextPage);
        redirectToV5Registration(handoffLoginData, token, {
          sameTab: true,
          extraParams: {
            nextPage,
          },
        });
        return;
      }
      if (shouldResolveChildrenStatusNextPage(nextPage)) {
        const token = response?.headers?.authorization;
        const handoffLoginData = yield call(
          resolveLoginV5HandoffData,
          loginData
        );
        persistLoginSessionForHandoff(handoffLoginData, token);
        storeV5LoginNextPage(nextPage);
        redirectToV5Registration(handoffLoginData, token, {
          sameTab: true,
          extraParams: {
            nextPage,
          },
        });
        return;
      }
      if (!nextPage || nextPage === "/" || normalizedNext === "signin") {
        history(
          resolvePostLoginPath(loginData, getSelectedVersion(loginData)),
          { replace: true }
        );
      } else {
        const path = resolvePostLoginPath(loginData, getSelectedVersion(loginData));
        localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, path);
        history(path, { replace: true });
      }
      return;
    }

    yield put(loginFromAdminSuccess(response));
  } catch (error) {
    yield put(loginFromAdminApiError(error));
  }
}

//login from admin
function* adminLoginUser({ payload: { user, history, from } }) {
  try {
    const response = yield call(from == "loginfromadmin" ? AdminLogin : from == "loginfromsms" ? SMSLogin : EmailLogin, user);
    if (response.data.status === "Success") {
      if (response?.data?.data?.popup) {
        const popupData = response.data.data.popup;
        sessionStorage.setItem('loginFromAdmin', JSON.stringify(popupData));
      }
      if (response.data.data.userId) {
        const otpSentVia = response?.data?.data?.otpSentVia;
        if (otpSentVia) localStorage.setItem(Constants.loginLocalStorageKeys.otpSentVia, otpSentVia);
        else localStorage.removeItem(Constants.loginLocalStorageKeys.otpSentVia);

        localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)


        if (usesLiteExperience(response.data.data?.selectedversion)) {
          localStorage.setItem("isV3User", true)
          const cms_response = yield call(CMS_Login_via, {
            // userId: response.data.data.userId,
            jwt_token: user.jwt ? user.jwt : undefined,
          });

          if (cms_response.data) {
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLogin,
              String(cms_response?.data?.access_token) ?? "OLD"
            );
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLoginId,
              String(cms_response?.data?.id) ?? ""
            );
          }
        }

        yield put(loginFromAdminSuccess(response));

        const token = response?.headers['authorization']; // Extract token

        localStorage.setItem(Constant.loginLocalStorageKeys.accessToken, token);
        // if (response?.data?.data?.popup) {
        //   const popupData = response.data.data.popup;
        //   sessionStorage.setItem('loginFromAdmin', JSON.stringify(popupData));
        // }

        if (response.data?.data?.KPcustomer != "Y") {
          localStorage.setItem(Constant.loginLocalStorageKeys.loginFromAdmin, true)
        }
        localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true) //is loggedin
        localStorage.setItem(Constant.loginLocalStorageKeys.loginName, response.data.data.userName ?? "") //username
        localStorage.setItem(Constant.loginLocalStorageKeys.loginEmail, response.data.data.userName ?? "")
        localStorage.setItem(Constant.loginLocalStorageKeys.loginId, response.data.data.userId) //userid
        const selfPayParam = user?.selfpay ?? new URLSearchParams(window.location.search).get("selfpay");
        const nextPage = selfPayParam?.toUpperCase() === "Y" ? RouteSegment.SELF_PAY : response.data.data.nextPage;

        localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${nextPage}`)
        localStorage.setItem(Constant.loginLocalStorageKeys.loginCheckForRquest,'loginCheckForReq')
         //for vernacular
         i18n.changeLanguage(response.data.data?.vernacularCode ?? "en")
         localStorage.setItem(Constant.loginLocalStorageKeys.vernacularCode, response.data.data.vernacularCode ?? "en")

        //to allow navigation into after reg page
        if (nextPage == RouteSegment.AFTER_REGISTRATION) {
          localStorage.setItem(Constants.loginLocalStorageKeys.allowAfterRegPage, "true")
          localStorage.removeItem("preferenceFlowState")
          localStorage.removeItem("parentsNumberFlowState")
          localStorage.removeItem("isOriginalImageUploaded")
       
          localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage, RouteSegment.AFTER_REGISTRATION)
        } else if (nextPage == "communityPayment") {
            history(RouteSegment.MATCH_LITE); 
        }
        if (nextPage === RouteSegment.SELF_PAY) {
          savePendingSelfPayPaymentFulfillment(user, response);
        }
        sessionStorage.setItem(Constants.loginLocalStorageKeys.skipAkshayaDefaultObjectCode6, "true");
        history(`${nextPage}`);
      }
      else {
        yield put(loginFromAdminSuccess(response));
      }
    } else {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginFromAdminApiError(response));
    }
  } catch (error) {
    yield put(loginFromAdminApiError(error));
  }
}

//login from partial admin
function* adminLoginPartialUser({ payload: { user, history, from } }) {
  try {
    const response = yield call(PartialAdminLogin, user);
    if (response.data.status === "Success") {
      if (response.data.data.userId) {
        const otpSentVia = response?.data?.data?.otpSentVia;
        if (otpSentVia) localStorage.setItem(Constants.loginLocalStorageKeys.otpSentVia, otpSentVia);
        else localStorage.removeItem(Constants.loginLocalStorageKeys.otpSentVia);

        localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
        yield put(loginFromAdminPartialSuccess(response));

        if (usesLiteExperience(response.data.data?.selectedversion)) {
          localStorage.setItem("isV3User", true)
          const cms_response = yield call(CMS_Login_via, {
            // userId: response.data.data.userId,
            jwt_token: user.jwt ? user.jwt : undefined,
          });

          if (cms_response.data) {
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLogin,
              String(cms_response?.data?.access_token) ?? "OLD"
            );
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLoginId,
              String(cms_response?.data?.id) ?? ""
            );
          }
        }

        const token = response?.headers['authorization']; // Extract token

        localStorage.setItem(Constant.loginLocalStorageKeys.accessToken, token);

        localStorage.setItem(Constant.loginLocalStorageKeys.loginFromAdmin, true)
        localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true) //is loggedin
        localStorage.setItem(Constant.loginLocalStorageKeys.loginName, response.data.data.userName ?? "") //username
        localStorage.setItem(Constant.loginLocalStorageKeys.loginEmail, response.data.data.userName ?? "")
        localStorage.setItem(Constant.loginLocalStorageKeys.loginId, response.data.data.userId) //userid
        localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${response.data.data.nextPage}`)
        localStorage.setItem(Constant.loginLocalStorageKeys.loginCheckForRquest,'loginCheckForReq')

         //for vernacular
         i18n.changeLanguage(response.data.data?.vernacularCode ?? "en")
         localStorage.setItem(Constant.loginLocalStorageKeys.vernacularCode, response.data.data.vernacularCode ?? "en")

        sessionStorage.setItem(Constants.loginLocalStorageKeys.skipAkshayaDefaultObjectCode6, "true");
        history(`${response.data.data.nextPage}`);
      }
      else {
        yield put(loginFromAdminPartialSuccess(response));
      }
    } else {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginFromAdminPartialApiError(response));
    }
  } catch (error) {
    yield put(loginFromAdminPartialApiError(error));
  }
}

//login from admin
function* adminEmailUser({ payload: { user, history, from } }) {
  try {
    const response = yield call(EmailLogin, {
      jwt: user.jwt ? user.jwt : undefined,
      photo: user.photo ? user.photo : undefined,
      otherMailFlag: user.otherMailFlag ? user.otherMailFlag : undefined,
      toProfileId: user.toProfileId ? user.toProfileId : undefined,
      matching: user.matching ? user.matching : undefined,
      editpreferences: user.editpreferences ? user.editpreferences : undefined,
      upgrade: user.upgrade ? user.upgrade : undefined,
      horoscope: user.horoscope ? user.horoscope : undefined,
      trust: user.trust ? user.trust : undefined,
      manage: user.manage ? user.manage : undefined,
      bridexmail: user.bridexmail ? user.bridexmail : undefined,
      profileId: user.profileId ? user.profileId : undefined,
      settings: user.settings ? user.settings : undefined,
      inboxunread: user.inboxunread ? user.inboxunread : undefined,
      upgradeFlag: user.upgradeFlag ? user.upgradeFlag : undefined,
      appoinment: user.appoinment ? user.appoinment : undefined,
      fairPolicyFlag: user.fairPolicyFlag ? user.fairPolicyFlag : undefined,
      muhurat: user.muhurat ? user.muhurat : undefined,
      parentsnumber: user.parentsnumber ? user.parentsnumber : undefined,
      email: user.email ? user.email : undefined,
      password: user.password ? user.password : undefined,
      profileRegisterFrom: user.profileRegisterFrom ? user.profileRegisterFrom : undefined,
      admuserid: user.admuserid ? user.admuserid : undefined,
      redirection:user.redirection ? user.redirection : undefined,
      emailLogId:user?.emailLogId ? user?.emailLogId : undefined,
      discountCode:getProvidedDiscountCode(user) ?? undefined,
      linkfrom:user?.linkfrom ? user?.linkfrom : undefined,
      Success:user?.Success ? user?.Success : undefined,
      akshayaTrackId :user?.akshayaTrackId ? user?.akshayaTrackId : undefined,
      packId : user?.packId ? user?.packId : undefined,
      selfpayId: getProvidedSelfPayId(user) ?? undefined,
      emailTrackId : user?.emailTrackId ? user?.emailTrackId : undefined,
      discount: user?.discount ? user?.discount : undefined,
      expiryDate: user?.expiryDate ? user?.expiryDate : undefined,
      miniPackMessageId : user?.miniPackMessageId ? user?.miniPackMessageId : undefined,

    });
    if (response.data.status === "Success") {
      if (response?.data?.data?.popup) {
        const popupData = response.data.data.popup;
        sessionStorage.setItem('loginFromEmail', JSON.stringify(popupData));
      }
      if (response.data.data.userId) {
        localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
        sessionStorage.setItem(Constants.loginLocalStorageKeys.skipAkshayaDefaultObjectCode6, "true");


        const isV3 = usesLiteExperience(response.data.data?.selectedversion);

        if (isV3) {
          localStorage.setItem("isV3User", true)
          const cms_response = yield call(CMS_Login_via, {
            // userId: response.data.data.userId,
            jwt_token: user.jwt ? user.jwt : undefined,
          });

          if (cms_response.data) {
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLogin,
              String(cms_response?.data?.access_token) ?? "OLD"
            );
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLoginId,
              String(cms_response?.data?.id) ?? ""
            );
          }
        }

        yield put(loginFromAdminSuccess(response));

        const token = response?.headers['authorization']; // Extract token

        localStorage.setItem(Constant.loginLocalStorageKeys.accessToken, token);
        localStorage.setItem(Constant.loginLocalStorageKeys.uploadFrom, response.data.data?.uploadFrom)
        localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true) //is loggedin
        localStorage.setItem(Constant.loginLocalStorageKeys.loginName, response.data.data.userName ?? "") //username
        localStorage.setItem(Constant.loginLocalStorageKeys.loginEmail, response.data.data.userName ?? "")
        localStorage.setItem(Constant.loginLocalStorageKeys.loginId, response.data.data.userId) //userid
        localStorage.setItem(Constant.loginLocalStorageKeys.loginCheckForRquest,'loginCheckForReq')
         //for vernacular
         i18n.changeLanguage(response.data.data?.vernacularCode ?? "en")
         localStorage.setItem(Constant.loginLocalStorageKeys.vernacularCode, response.data.data.vernacularCode ?? "en")
        yield call(trackSelfPayClick, user, response);
        const redirectionPage = getLoginRedirection(user?.redirection);
        if (redirectionPage) {
          localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${redirectionPage}`)
          if (redirectionPage === RouteHelper.getEditProfileUrl(EditProfileMenu[2].urlPath)) {
            localStorage.setItem("isFromMyPhotoPage", true)
            savePendingSelfPayPhotoFulfillment(user, response);
            history(redirectionPage, { replace: true, state: { isFrom: "myPhotoPage" } });
          } else if (redirectionPage === RouteSegments.MATCH_LITE) {
            savePendingSelfPayMatchesFulfillment(user, response);
            history(redirectionPage, { replace: true });
          } else if (redirectionPage === RouteSegments.SELF_PAY) {
            savePendingSelfPayPaymentFulfillment(user, response);
            history(redirectionPage, { replace: true });
          } else {
            history(redirectionPage, { replace: true });
          }
          return;
        }
        if (response.data.data?.nextPage === RouteHelper.getProfileUrl) {
          history(`${response.data.data.nextPage}`, { replace: true, state: { id: user.toProfileId } });
        } else if (response.data.data?.nextPage === RouteSegments.MATCH_LITE && user.toProfileId) {
          history(RouteSegments.MATCH_CONVERSATIONS_LITE, {
            state: {
              isFrom: "login",
              id: "KM" + user.toProfileId,
              isFromChat: false,
              from: "search"
            }
          })
        }
        else if (response.data.data?.nextPage === "/communityPayment") {
          history(RouteSegments.COMMUNITY_PAYMENT, { replace: true });
        
          const getCommunityPaymentToken = async () => {
            try {
              const communityPaymentRequest = {
                loginFrom: localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
              };
        
              const communityPaymentResponse = await POST(
                `${config.api.API_URL}${EndPoints.communityPaymentUrl()}`,
                communityPaymentRequest
              );
        
              if ( communityPaymentResponse?.data?.status === "Success"  ) {
                const token = communityPaymentResponse.data.data.paymentToken;
        
                localStorage.setItem(Constants.loginLocalStorageKeys.EmailPaymentTocken, token);
              } else {
                console.error("Community payment API failed", communityPaymentResponse);
              }
            } catch (err) {
              console.error("Error calling community payment API:", err);
            }
          };
        
          getCommunityPaymentToken(); // 🔔 Call the async function
        }
        else if (response.data.data?.nextPage === "akshayaPopup") {
          const context = {
            source: "email",
            objectCode: "4",
            emailLogId: user?.emailLogId ?? null,
            packId: response?.data?.data?.packId ?? null,
            akshayaTrackId: response?.data?.data?.akshayaTrackId ?? null,
          };
          sessionStorage.setItem("akshayaPopupContext", JSON.stringify(context));
          history(RouteSegments.MATCH_LITE, { replace: true, state: { akshayaPopup: true } });
        }
        else if (response.data.data?.nextPage === "/billdesk") {
            try {
              localStorage.setItem("isFromPayBilldeskLink", "true");
              const billdeskStateKey = `billdeskSmsState_${user?.smslogId ?? "default"}`;
              const billdeskState = sessionStorage.getItem(billdeskStateKey);

              if (billdeskState === "processing" || billdeskState === "done") {
                sessionStorage.removeItem(billdeskStateKey);
                history(RouteSegments.MEMBERSHIP_REGISTER(), { replace: true });
                return;
              }
              sessionStorage.setItem(billdeskStateKey, "processing");

              const resolvedAkshayaTrackId =
                response?.data?.data?.akshayaTrackId ?? user?.akshayaTrackId ?? null;
              const resolvedPack = (() => {
                const data = response?.data?.data;
                if (Array.isArray(data?.pack)) return data.pack.map((packId) => String(packId));
                if (data?.packId !== undefined && data?.packId !== null && String(data.packId).trim() !== "") {
                  return [String(data.packId)];
                }
                if (data?.pack !== undefined && data?.pack !== null && String(data.pack).trim() !== "") {
                  return [String(data.pack)];
                }
                if (user?.packId !== undefined && user?.packId !== null && String(user.packId).trim() !== "") {
                  return [String(user.packId)];
                }
                if (Array.isArray(user?.pack)) return user.pack.map((packId) => String(packId));
                if (user?.pack !== undefined && user?.pack !== null && String(user.pack).trim() !== "") {
                  return [String(user.pack)];
                }
                return [];
              })();

              const billdeskRequest = {
                email: response?.data?.data?.userName ?? user?.email,
                userId: response?.data?.data?.userId,
                pack: resolvedPack,
                discount: response?.data?.data?.discountCode ?? getProvidedDiscountCode(user),
                loginFrom: localStorage.getItem(Constant.loginLocalStorageKeys.loginDevice) ?? "Desktop",
              };

              const billdeskResponse = yield call(
                POST,
                `${config.api.API_URL}${EndPoints.generatePaymentTokenUrl()}`,
                billdeskRequest
              );

              const paymentToken = billdeskResponse?.data?.data?.paymentToken;
              if (
                billdeskResponse?.statusCode === 200 &&
                billdeskResponse?.data?.status === "Success" &&
                paymentToken
              ) {
                sessionStorage.setItem(billdeskStateKey, "done");
                if (resolvedAkshayaTrackId && resolvedPack.length > 0) {
                  localStorage.setItem("akshayaTrackId", String(resolvedAkshayaTrackId));
                  localStorage.setItem("akshayaPack", JSON.stringify(resolvedPack));
                  try {
                    const trackDedupeKey = `akshayaBilldeskClick_${resolvedAkshayaTrackId}_${resolvedPack.join("_")}`;
                    if (sessionStorage.getItem(trackDedupeKey) !== "true") {
                      const trackPackKey = resolvedPack[0] ?? "";
                      yield call(POST, `${config.api.API_URL}${EndPoints.updateAkshayatrackDetails()}`, {
                        email: billdeskRequest.email,
                        userId: billdeskRequest.userId,
                        packId: String(trackPackKey),
                        loginFrom: billdeskRequest.loginFrom,
                        akshayaTrackId: resolvedAkshayaTrackId,
                        action: "click",
                      });
                      sessionStorage.setItem(trackDedupeKey, "true");
                    }
                  } catch {
                    // non-blocking for payment redirect
                  }
                }
                window.location.href = paymentToken;
              } else {
                sessionStorage.removeItem(billdeskStateKey);
                history(RouteSegments.MEMBERSHIP_REGISTER(), { replace: true });
              }
            } catch (error) {
              const billdeskStateKey = `billdeskSmsState_${user?.smslogId ?? "default"}`;
              sessionStorage.removeItem(billdeskStateKey);
              history(RouteSegments.MEMBERSHIP_REGISTER(), { replace: true });
            }
        }
        
         else {
          localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${response.data.data.nextPage}`)
          history(`${response.data.data.nextPage}`, { replace: true });
        }
      }
      else {
        yield put(loginFromAdminSuccess(response));
      }
    } else {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginFromEmailApiError(response));
    }
  } catch (error) {
    yield put(loginFromEmailApiError(error));
  }
}

//login from sms
function* adminSMSUser({ payload: { user, history, from } }) {
  try {
    const resolvedFamilyLoginId = user?.familyLoginId ?? user?.familyLoginID;
    let parsedPack = user?.pack;
    if (typeof user?.pack === "string") {
      try {
        const packValue = JSON.parse(user.pack);
        if (Array.isArray(packValue)) {
          parsedPack = packValue;
        }
      } catch {
      }
    }

    const response = yield call(SMSLogin, {
      jwt: user.jwt ? user.jwt : undefined,
      profiletoken: user.profiletoken ? user.profiletoken : undefined,
      photo: user.photo ? user.photo : undefined,
      otherMailFlag: user.otherMailFlag ? user.otherMailFlag : undefined,
      toProfileId: user.toProfileId ? user.toProfileId : undefined,
      matching: user.matching ? user.matching : undefined,
      editpreferences: user.editpreferences ? user.editpreferences : undefined,
      upgrade: user.upgrade ? user.upgrade : undefined,
      upgradeFlag: user.upgradeFlag ? user.upgradeFlag : undefined,
      horoscope: user.horoscope ? user.horoscope : undefined,
      trust: user.trust ? user.trust : undefined,
      manage: user.manage ? user.manage : undefined,
      bridexmail: user.bridexmail ? user.bridexmail : undefined,
      profileId: user.profileId ? user.profileId : undefined,
      settings: user.settings ? user.settings : undefined,
      email: user.email ? user.email : undefined,
      password: user.password ? user.password : undefined,
      inboxunread: user.inboxunread ? user.inboxunread : undefined,
      appoinment: user.appoinment ? user.appoinment : undefined,
      fairPolicyFlag: user.fairPolicyFlag ? user.fairPolicyFlag : undefined,
      muhurat: user.muhurat ? user.muhurat : undefined,
      parentsnumber: user.parentsnumber ? user.parentsnumber : undefined,
      mobileverification: user.mobileverification ? user.mobileverification : undefined,
      pp_matches: user.pp_matches ? user.pp_matches : undefined,
      replypending: user.replypending ? user.replypending : undefined,
      recommendation: user.recommendation ? user.recommendation : undefined,
      parentsMobileNumber: user.parentsMobileNumber ? user?.parentsMobileNumber : undefined,
      whatsappverified: user.whatsappverified ? user?.whatsappverified : undefined,
      offlinepack: user.offlinepack ? user?.offlinepack : undefined,
      mobilenumber: user.mobilenumber ? user?.mobilenumber : undefined,
      loginfrom: user.loginfrom ? user?.loginfrom : undefined,
      startmessage: user.startmessage ? user?.startmessage : undefined,
      iswhatsappClick: user.iswhatsappClick ? user?.iswhatsappClick : undefined,
      messageId: user.messageId ? user?.messageId : undefined,
      trialpackpopup: user?.trialpackpopup ? user?.trialpackpopup : undefined,
      whoviewedmyprofile: user?.whoviewedmyprofile ? user?.whoviewedmyprofile : undefined,
      starraasipopup: user?.starraasipopup ? user?.starraasipopup : undefined,
      notificationId: user?.notificationId ? user?.notificationId : undefined,
      privacypopup: user?.privacypopup ? user?.privacypopup : undefined,
      horoscopepopup: user?.horoscopepopup ? user?.horoscopepopup : undefined,
      receiverId: user?.receiverId ? user?.receiverId : undefined,
      requesttypeid: user?.requesttypeid ? user?.requesttypeid : undefined,
      smslogId: user?.smslogId ? user?.smslogId : undefined,
      senderId: user?.senderId ? user?.senderId : undefined,
      loginFrom: user?.loginFrom ? user?.loginFrom : undefined,
      fromclc: user?.fromclc ? user?.fromclc : undefined,
      redirection:user.redirection ? user.redirection : undefined,
      loginviawhatsappphoto:user?.loginviawhatsappphoto ? user?.loginviawhatsappphoto : undefined,
      popupFrom: user?.popupFrom ? user?.popupFrom : undefined,
      micrositefaq:user?.micrositefaq? user?.micrositefaq :undefined,
      PhotoPreview:user?.PhotoPreview ? user?.PhotoPreview :undefined ,
      //  
      logId:user?.logId ? user?.logId :undefined ,
      kp_profileid:user?.kp_profileid ? user?.kp_profileid :undefined ,
      key:user?.key ? user?.key :undefined ,
      source_profile_id:user?.source_profile_id ? user?.source_profile_id :undefined ,
      admUserId:user?.admUserId ? user?.admUserId :undefined ,
      sourceUserId:user?.sourceUserId ? user?.sourceUserId :undefined ,
      kpUserId:user?.kpUserId ? user?.kpUserId :undefined ,
      autoCusLogId:user?.autoCusLogId ? user?.autoCusLogId :undefined ,
      photoapproved:user?.photoapproved ? user?.photoapproved :undefined ,
      photorejected:user?.photorejected ? user?.photorejected : undefined,
      viewProfileMessageId:user?.viewProfileMessageId ? user?.viewProfileMessageId : undefined,
      paymentMessageId:user?.paymentMessageId ? user?.paymentMessageId : undefined,

      eventTrackId:user?.eventTrackId ? user?.eventTrackId : undefined,
      clickAction:user?.clickAction ? user?.clickAction : undefined,
      clickButton:user?.clickButton ? user?.clickButton : undefined,
      surveyId:user?.surveyId ? user?.surveyId : undefined,
      meetId:user?.meetId ? user?.meetId : undefined,
      logTableId:user?.logTableId ? user?.logTableId : undefined,
      autoCusLogId:user?.autoCusLogId ? user?.autoCusLogId : undefined,
      kp_profileId:user?.kp_profileId ? user?.kp_profileId : undefined,
      familyNumber:user?.familyNumber ? user?.familyNumber : undefined,
      emailLogId:user?.emailLogId ? user?.emailLogId : undefined,
      discountCode:getProvidedDiscountCode(user) ?? undefined,
      linkfrom:user?.linkfrom ? user?.linkfrom : undefined,
      pack:parsedPack ? parsedPack : undefined,
      familyLoginId : resolvedFamilyLoginId ? resolvedFamilyLoginId : undefined,
      Success:user?.Success ? user?.Success : undefined,
      akshayaTrackId :user?.akshayaTrackId ? user?.akshayaTrackId : undefined,
      packId : user?.packId ? user?.packId : undefined,
      emailTrackId : user?.emailTrackId ? user?.emailTrackId : undefined,
      selfpayId: getProvidedSelfPayId(user) ?? undefined,
       discount: user?.discount ? user?.discount : undefined,
       expiryDate: user?.expiryDate ? user?.expiryDate : undefined,
       miniPackMessageId : user?.miniPackMessageId ? user?.miniPackMessageId : undefined,

    });
 
    if (response.data.status === "Success") {
      if (response.data.data.userId) {
        if (user.notificationId) {
          const res = yield call(Update_Notification_Status, {
            "email": user.email,
            "userId": response.data.data.userId,
            "isClicked": true,
            "notificationId": user.notificationId,
        ...(user.clickButton != null && { clickButton: user.clickButton }),
          })
          localStorage.setItem("clcpopupnotificationId", user.notificationId);
        }
        if(user.eventTrackId){
             const discountCode = getProvidedDiscountCode(user);
             localStorage.setItem("eventTrackId", user.eventTrackId);
             if (discountCode) {
               localStorage.setItem("discountCode", discountCode);
             }
        }
        if(user.clickButton){
          localStorage.setItem("clickButton", user.clickButton);
        }
        localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
        if (user.toProfileId) {
          localStorage.setItem('toProfileId', user.toProfileId);
        }

        if (response?.data?.data?.popup) {
          const popupData = response.data.data.popup;
          sessionStorage.setItem('loginFromSMS', JSON.stringify(popupData));
        }
        if(user?.redirection && user?.redirection != "undefined" && user?.redirection != "null" && user?.redirection == "upgrade" && user.eventTrackId){
          localStorage.setItem("eventTrackIdPlan", user.eventTrackId);
        }

        if (usesLiteExperience(response.data.data?.selectedversion)) {
          localStorage.setItem("isV3User", true)
          const cms_response = yield call(CMS_Login_via, {
            // userId: response.data.data.userId,
            jwt_token: user.jwt ? user.jwt : undefined,
          });

          if (cms_response.data) {
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLogin,
              String(cms_response?.data?.access_token) ?? "OLD"
            );
            localStorage.setItem(
              Constant.loginLocalStorageKeys.chatLoginId,
              String(cms_response?.data?.id) ?? ""
            );

          }
          
          if(response.data.data?.nextPage ==RouteSegments.PROFILE_PREVIEW){
            // localStorage.setItem("profiledot", true);
           
            // history(`${RouteSegments.PROFILE_PREVIEW}`, {
            //   replace: true,
            //   state: { isFrom: "profile_preview_threedots", nextPage: response.data.data.nextPage },
            // });
            
            localStorage.setItem("profiledot", true);
            history(RouteSegments.PROFILE_PREVIEW, { state: { isFrom: "profile_preview_threedots" } });
          }
            if (response.data.data.nextPage === "/manage/new/photos?myPhotosPage") {
              localStorage.setItem("isFromMyPhotoPage", true)

              history(RouteHelper.getEditProfileUrl(EditProfileMenu[3].urlPath), {
                replace: true,
                state: {
                  isFrom: "myPhotoPage",
                },
              });
            }
         if (response.data.data.nextPage === "/new/my-plan") {
              // localStorage.setItem("isFromMyPhotoPage", true)

              history(RouteHelper.getEditProfileUrl(EditProfileMenu[7].urlPath), {
                replace: true,
                state: {
                  isFrom: "myPlanPage",
                },
              });
            }
            if(response.data.data?.nextPage === "/new/successstory"){
              history(RouteHelper.getEditProfileUrl(), {
                replace: true,
                state: {
                  isFrom: "successStoryPage",
                },
              });
            }
            
            
        }

        yield put(loginFromAdminSuccess(response));

        const token = response?.headers['authorization']; // Extract token

        localStorage.setItem(Constant.loginLocalStorageKeys.accessToken, token);
        localStorage.setItem(Constant.loginLocalStorageKeys.uploadFrom, response.data.data?.uploadFrom)

        localStorage.setItem(Constants.loginLocalStorageKeys.Notification,response.data.data?.notificationId)

          sessionStorage.setItem(Constants.loginLocalStorageKeys.loginUrl, window.location.href)

        

        sessionStorage.setItem(Constants.loginLocalStorageKeys.loginFromUrl, window.location.href)

        
        // Avoid showing MobileSiteLoginPopup for Akshaya popup and Mini Packs redirects in SMS-login flow.
        // (MobileSiteLoginPopup is driven by `isLoginFromSms` session key.)
        const shouldSetIsLoginFromSms = (() => {
          const nextPage = response?.data?.data?.nextPage;
          const normalizedNext = String(nextPage ?? "").trim().toLowerCase();
          if (normalizedNext === "akshayapopup") return false;
          if (
            normalizedNext === RouteSegments.MINI_PACKS.toLowerCase() ||
            normalizedNext.includes("/minipacks")
          ) {
            return false;
          }

          try {
            const url = new URL(window.location.href);
            const redirection = url.searchParams.get("redirection");
            const normalizedRedirection = String(redirection ?? "").trim().toLowerCase();
            if (normalizedRedirection === "akshayapopup") return false;
            if (normalizedRedirection.includes("minipack")) return false;
          } catch {
            // ignore invalid URL parsing
          }

          return true;
        })();

        if (shouldSetIsLoginFromSms) {
          sessionStorage.setItem(Constants.loginLocalStorageKeys.isLoginFromSms, "true")
        } else {
          sessionStorage.removeItem(Constants.loginLocalStorageKeys.isLoginFromSms)
        }
        sessionStorage.setItem(Constants.loginLocalStorageKeys.skipAkshayaDefaultObjectCode6, "true");
        localStorage.setItem(Constants.loginLocalStorageKeys.isLoginSmsviewnumber, response.data.data?.clickAction === "viewnumber" ? "true" : "false" )

        localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true) //is loggedin
        localStorage.setItem(Constant.loginLocalStorageKeys.loginName, response.data.data.userName ?? "") //username
        localStorage.setItem(Constant.loginLocalStorageKeys.loginEmail, response.data.data.userName ?? "")
        localStorage.setItem(Constant.loginLocalStorageKeys.loginId, response.data.data.userId) //userid
        localStorage.setItem(Constant.loginLocalStorageKeys.loginCheckForRquest,'loginCheckForReq')
        localStorage.setItem(Constants.loginLocalStorageKeys.loginFrom, window.location.href)

         //for vernacular
         i18n.changeLanguage(response.data.data?.vernacularCode ?? "en")
         localStorage.setItem(Constant.loginLocalStorageKeys.vernacularCode, response.data.data.vernacularCode ?? "en")
        if (user.notificationId) {
          sessionStorage.setItem(Constant.loginLocalStorageKeys.notificationId, user.notificationId)
          sessionStorage.setItem(Constants.loginLocalStorageKeys.loginUrl, window.location.href)
        }
         if (user.eventTrackId) {
          sessionStorage.setItem(Constants.loginLocalStorageKeys.loginUrl, window.location.href)
        }
        if(user.startmessage == 'Y'){
          sessionStorage.setItem('startMessage',user.startmessage)
        }
        localStorage.setItem(Constants.loginLocalStorageKeys.trailPack, response.data.data?.trialPackPopup)
        
        if(user?.notificationId){
          localStorage.setItem("notifyId", true);
        }else if(!user?.notificationId) {
          localStorage.setItem("notifyId", 'false');
        }
        if(user?.popupFrom){
          localStorage.setItem("popupFromApp", true);
        }
        if(user.inboxunread == 'Y'){
          sessionStorage.setItem('ReadAndReply',user.inboxunread)
        }

        yield call(trackSelfPayClick, user, response);
        const redirectionPage = getLoginRedirection(user?.redirection);
        if (redirectionPage) {
          localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${redirectionPage}`)
          if (redirectionPage === RouteHelper.getEditProfileUrl(EditProfileMenu[2].urlPath)) {
            localStorage.setItem("isFromMyPhotoPage", true)
            savePendingSelfPayPhotoFulfillment(user, response);
            history(redirectionPage, { replace: true, state: { isFrom: "myPhotoPage" } });
          } else if (redirectionPage === RouteSegments.MATCH_LITE) {
            savePendingSelfPayMatchesFulfillment(user, response);
            history(redirectionPage, { replace: true });
          } else if (redirectionPage === RouteSegments.SELF_PAY) {
            savePendingSelfPayPaymentFulfillment(user, response);
            history(redirectionPage, { replace: true });
          } else {
            history(redirectionPage, { replace: true });
          }
          return;
        }
        
        if (response.data.data?.nextPage === RouteHelper.getProfileUrl) {
          history(`${response.data.data.nextPage}`, { replace: true, state: { id: user.toProfileId } });
        } else if (response.data.data?.nextPage === RouteSegments.MATCH_LITE && user.toProfileId) {
          history(RouteSegments.MATCH_CONVERSATIONS_LITE, {
            state: {
              isFrom: "login",
              id: "KM" + user.toProfileId,
              isFromChat: false,
              from: "search"
            }
          })
        } else if (response.data.data?.nextPage.includes(RouteSegments.OFFLINE_PROFLIE) && user.toProfileId) {          
          history(`${response.data.data.nextPage}`, {
            replace: true,
            state: {
              isFrom: "login",
              profile_id: user.toProfileId
            }
          })
        }
        else if (response.data.data?.nextPage === RouteSegments.TRIALPACK && user.toProfileId) {
          history(`${response.data.data.nextPage}`, {
            replace: true,
            state: {
              isFrom: "login",
              profile_id: user.toProfileId
            }
          })
        }
        else if (response.data.data?.nextPage === RouteSegments.STAR_RAASI && user.toProfileId) {
          history(`${response.data.data.nextPage}`, {
            replace: true,
            state: {
              isFrom: "login",
              profile_id: user.toProfileId
            }
          })
        }
        else if (response.data.data?.nextPage === RouteSegments.PRIVACYPOPUP && user.toProfileId) {
          history(`${response.data.data.nextPage}`, {
            replace: true,
            state: {
              isFrom: "login",
              profile_id: user.toProfileId
            }
          })
        }
        else if(response.data.data?.nextPage ==RouteSegments.PROFILE_PREVIEW){
          history(`${response.data.data.nextPage}`, {
            replace: true,
          
          }) 
        }
         else if (response.data.data.nextPage === "/manage/new/photos?myPhotosPage") {
            localStorage.setItem("isFromMyPhotoPage", true)

            history(RouteHelper.getEditProfileUrl(EditProfileMenu[2].urlPath), {
              replace: true,
              state: {
                isFrom: "myPhotoPage",
              },
            });
          }
        else if (response.data.data?.nextPage?.includes(RouteSegments.PROFILE_PDF_VIEW)) {
          if(response.data?.statusCode == 200){
            history(`${response.data.data.nextPage}`, {
              replace: true
            });
            localStorage.setItem("pdfLogId",user?.logId);
            localStorage.setItem("pdfKpProfileId",user?.kp_profileid);
            localStorage.setItem("pdfKey",user?.key);
            localStorage.setItem("pdfSourceProfileId",user?.source_profile_id);
            localStorage.setItem("pdfAdmUserId",user?.admUserId);
            localStorage.setItem("pdfUserId",response.data.data?.userId)
            localStorage.setItem("pdfSourceUserId",user?.sourceUserId);
            localStorage.setItem("pdfKPUserId",user?.kpUserId);
            localStorage.setItem("pdfAutoCusId",user?.autoCusLogId)
          }
        }
        else if (response.data.data?.nextPage?.includes(RouteSegments.MEET_PROFILE_PDF_VIEW)) {
          if(response.data?.statusCode == 200){
            history(`${response.data.data.nextPage}`, {
              replace: true
            });
            console.log("isFeedbackSubmitted",response.data.data.isFeedbackSubmitted);
            localStorage.setItem("pdfMeetId",user?.meetId);
            localStorage.setItem("pdfLogTableId",user?.logTableId);
            localStorage.setItem("pdfAutoCusLogId",user?.autoCusLogId);
            localStorage.setItem("isFeedBackSubmited",response.data.data.isFeedbackSubmitted);
            localStorage.setItem("pdfUserId",response.data.data?.userId);
             localStorage.setItem("pdfKey",user?.key);
              localStorage.setItem("pdfKpProfileId",user?.kp_profileId);
               localStorage.setItem("pdfSourceUserId",user?.sourceUserId);

          }
        }

      else if (response.data.data?.nextPage?.includes(RouteSegments.PROFILE_SURVEY_PAGE)) {
          if(response.data?.statusCode == 200){
            history(`${response.data.data.nextPage}`, {
              replace: true
            });
            localStorage.setItem("surveyId",user?.surveyId);
            localStorage.setItem("isFeedbackSubmitted",response.data.data.isFeedbackSubmitted);


          }
        }


        else if (user.mobilenumber == "Y" && user.toProfileId) {
          if (response.data.data?.selectedversion == "V2") {

            const cms_response = yield call(CMS_Login_via, {
              jwt_token: user.jwt ? user.jwt : undefined,
            });

            if (cms_response.data) {
              localStorage.setItem(
                Constant.loginLocalStorageKeys.chatLogin,
                String(cms_response?.data?.access_token) ?? "OLD"
              );
              localStorage.setItem(
                Constant.loginLocalStorageKeys.chatLoginId,
                String(cms_response?.data?.id) ?? ""
              );
            }
          }

          history(RouteSegments.OFFLINE_PROFLIE, { replace: true, state: { isFrom: "login", profile_id: user.toProfileId, isPhonePopup: user.mobilenumber } });
        }
        else if (response.data.data?.nextPage === RouteSegments.HOROSCOPE && user.toProfileId) {
          history(`${response.data.data.nextPage}`, {
            replace: true,
            state: {
              isFrom: "login",
              profile_id: user.toProfileId
            }
          })
        }
        else if (response.data.data?.nextPage === RouteSegments?.MATCH_CONVERSATIONS_LITE && response.data.data?.requestTypeId) {
          history(RouteSegments.MATCH_CONVERSATIONS_LITE, {
            state: {
              isFrom: "login",
              id: "KM" + user?.senderId, 
              isFromChat: true,
              from: "newConversations",
              message_type:response.data.data?.requestTypeId
            }
          })
        }
        else if (response.data.data?.nextPage === RouteSegments?.CHAT_LITE && user?.senderId) {
          history(RouteSegments.MATCH_CONVERSATIONS_LITE, {
            state: {
              isFrom: "login",
              id: "KM" + user?.senderId,
              isFromChat: true,
              from: "newConversations",
            }
          })
        } 
        else if (response.data.data?.nextPage === RouteSegments.KALYAN_PREMIER) {
              // window.open(RouteSegments.KALYAN_PREMIER, "_blank");
              history(RouteSegments.MATCH_LITE, {
                replace: true 
            });
            
          // Then navigate to Kalyan Premier
          history(RouteSegments.KALYAN_PREMIER);
        } else if (response.data.data.nextPage == "communityPayment") {
            history(RouteSegment.COMMUNITY_PAYMENT); 

            try {
              const communityPaymentResponse = yield call(CommunityPayment, {
                loginFrom: localStorage.getItem(Constant.loginLocalStorageKeys.loginDevice),
              });
          
              if (communityPaymentResponse?.data?.status === "Success") {
                const paymentToken = communityPaymentResponse.data?.data?.paymentToken;
                   console.log(communityPaymentResponse,"communityPaymentResponse");

                // Optionally store anything else if needed
                localStorage.setItem(Constants.loginLocalStorageKeys.paymentToken, paymentToken);
                localStorage.setItem('paymentTokens', paymentToken);

              } else {
                // Handle failure if needed
                yield put(apiError(communityPaymentResponse));
              }
            } catch (error) {
              yield put(apiError(error));
            }
        } else if (response.data.data?.nextPage === "akshayaPopup") {
            const context = {
              source: "sms",
              objectCode: "1",
              smslogId: user?.smslogId ?? null,
              packId: response?.data?.data?.packId ?? user?.packId ?? null,
              akshayaTrackId: response?.data?.data?.akshayaTrackId ?? user?.akshayaTrackId ?? null,
            };
            sessionStorage.setItem("akshayaPopupContext", JSON.stringify(context));
            history(RouteSegments.MATCH_LITE, { replace: true, state: { akshayaPopup: true } });
        } else if (response.data.data?.nextPage === "/billdesk") {
            try {
              localStorage.setItem("isFromPayBilldeskLink", "true");
              const billdeskStateKey = `billdeskSmsState_${user?.smslogId ?? "default"}`;
              const billdeskState = sessionStorage.getItem(billdeskStateKey);

              if (billdeskState === "processing" || billdeskState === "done") {
                sessionStorage.removeItem(billdeskStateKey);
                history(RouteSegments.MEMBERSHIP_REGISTER(), { replace: true });
                return;
              }
              sessionStorage.setItem(billdeskStateKey, "processing");

              const resolvedAkshayaTrackId =
                response?.data?.data?.akshayaTrackId ?? user?.akshayaTrackId ?? null;
              const resolvedPack = (() => {
                const data = response?.data?.data;
                if (Array.isArray(data?.pack)) return data.pack.map((packId) => String(packId));
                if (data?.packId !== undefined && data?.packId !== null && String(data.packId).trim() !== "") {
                  return [String(data.packId)];
                }
                if (data?.pack !== undefined && data?.pack !== null && String(data.pack).trim() !== "") {
                  return [String(data.pack)];
                }
                if (user?.packId !== undefined && user?.packId !== null && String(user.packId).trim() !== "") {
                  return [String(user.packId)];
                }
                if (Array.isArray(user?.pack)) return user.pack.map((packId) => String(packId));
                if (user?.pack !== undefined && user?.pack !== null && String(user.pack).trim() !== "") {
                  return [String(user.pack)];
                }
                return [];
              })();

              const billdeskRequest = {
                email: response?.data?.data?.userName ?? user?.email,
                userId: response?.data?.data?.userId,
                pack: resolvedPack,
                discount: response?.data?.data?.discountCode ?? getProvidedDiscountCode(user),
                loginFrom: localStorage.getItem(Constant.loginLocalStorageKeys.loginDevice) ?? "Desktop",
              };

              const billdeskResponse = yield call(
                POST,
                `${config.api.API_URL}${EndPoints.generatePaymentTokenUrl()}`,
                billdeskRequest
              );

              const paymentToken = billdeskResponse?.data?.data?.paymentToken;
              if (
                billdeskResponse?.statusCode === 200 &&
                billdeskResponse?.data?.status === "Success" &&
                paymentToken
              ) {
                sessionStorage.setItem(billdeskStateKey, "done");
                if (resolvedAkshayaTrackId && resolvedPack.length > 0) {
                  localStorage.setItem("akshayaTrackId", String(resolvedAkshayaTrackId));
                  localStorage.setItem("akshayaPack", JSON.stringify(resolvedPack));
                  try {
                    const trackDedupeKey = `akshayaBilldeskClick_${resolvedAkshayaTrackId}_${resolvedPack.join("_")}`;
                    if (sessionStorage.getItem(trackDedupeKey) !== "true") {
                      const trackPackKey = resolvedPack[0] ?? "";
                      yield call(POST, `${config.api.API_URL}${EndPoints.updateAkshayatrackDetails()}`, {
                        email: billdeskRequest.email,
                        userId: billdeskRequest.userId,
                        packId: String(trackPackKey),
                        loginFrom: billdeskRequest.loginFrom,
                        akshayaTrackId: resolvedAkshayaTrackId,
                        action: "click",
                      });
                      // sessionStorage.setItem(trackDedupeKey, "true");
                    }
                  } catch {
                    // non-blocking for payment redirect
                  }
                }
                window.location.href = paymentToken;
              } else {
                sessionStorage.removeItem(billdeskStateKey);
                history(RouteSegments.MEMBERSHIP_REGISTER(), { replace: true });
              }
            } catch (error) {
              const billdeskStateKey = `billdeskSmsState_${user?.smslogId ?? "default"}`;
              sessionStorage.removeItem(billdeskStateKey);
              history(RouteSegments.MEMBERSHIP_REGISTER(), { replace: true });
            }
        }else if(response.data.data?.nextPage === "/profileblastloadmore"){
           let list = FilterOptions.filter(data => data.id == 20).map(data => ({ ...data, getRequest: null, isChecked: true }))
           sessionStorage.setItem(Constants.loginLocalStorageKeys.filterState, JSON.stringify({ isFrom: "clcpopup", selectedFilter: list }))
           history(RouteSegments.MATCH_LITE, { state: { isFrom: "clcpopup", selectedFilter: list } })

        }
        else {
          localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${response.data.data.nextPage}`)

          //to allow navigation into after reg page
          if (response.data.data.nextPage == RouteSegment.AFTER_REGISTRATION || response.data.data.nextPage.includes(RouteSegment.AFTER_REGISTRATION)) {
            localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage, RouteSegment.AFTER_REGISTRATION)
            localStorage.setItem(Constants.loginLocalStorageKeys.allowAfterRegPage, "true")
            localStorage.removeItem("preferenceFlowState")
            localStorage.removeItem("parentsNumberFlowState")
            localStorage.removeItem("isOriginalImageUploaded")
          }
          let state = {};
          const redirectUrl = `${response.data.data.nextPage}`;

          if (redirectUrl.includes(RouteSegment.MATCH_GROUP)) {
            state.data = response?.data?.data
            localStorage.setItem(Constants.loginLocalStorageKeys.familyLoginId, resolvedFamilyLoginId);
             console.log(resolvedFamilyLoginId,'user?.familyLoginId');
          } else if (redirectUrl.includes(RouteSegment.CHAT_LITE)) {
            state.data = response?.data?.data
          }

          history(`${response.data.data.nextPage}`, { replace: true, state });
        }
      }
      else {
        localStorage.removeItem("loginsms");
        yield put(loginFromAdminSuccess(response));
      }
    } else {
      localStorage.removeItem("loginsms")
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginFromAdminApiError(response));
    }
  } catch (error) {
    yield put(loginFromAdminApiError(error));
  }
}

function* successStoryLoginUser({ payload: { user, history } }) {
  try {
     const payload = {
      jwt: user.jwt,
      issuccesslink: user.issuccesslink,
    };
    if (user.messageId) {
      payload.messageId = user.messageId;
    }
    if (user.admuserid) {
      payload.admuserid = user.admuserid;
    }
    const response = yield call(SuccessStoryLogin, payload);

    if (response.data.message === "Success") {
      
      const userData = response.data.data;

      // Save user info
      localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true);
      localStorage.setItem(Constant.loginLocalStorageKeys.loginId, userData.profileId);
      
      const token = response?.headers['authorization'];
      if(token) {
        localStorage.setItem(Constant.loginLocalStorageKeys.accessToken, token);
      }
      // if (user.admuserid) {
      //   localStorage.setItem("admuserid", user.admuserid);
      // }

      yield put(successstoryformSuccess(response));

      history(userData?.nextPage || RouteSegments.SUCCESS_STORY_PAGE);

    } else {
      yield put(successstoryformError(response));
    }
  } catch (error) {
    yield put(successstoryformError(error));
  }
}

//akhayatritiya
function* akhayatritiyaUser({ payload: { user, history, from } }) {
  try {
    const response = yield call(AkhayatritiyaLogin, {
      profileId: user.profileId ? user.profileId : undefined,
      mobileNumber: user.mobileNumber ? user.mobileNumber : undefined,
      sentFrom: user.sentFrom ? user.sentFrom : undefined
    });
    if (response.data.status === "Success") {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginForAkhayatritiyaSuccess(response));

      if (usesLiteExperience(response.data.data?.selectedversion)) {
        localStorage.setItem("isV3User", true)
        const cms_response = yield call(CMS_Login_via, {
          userId: response.data.data.userId,
        });

        if (cms_response.data) {
          localStorage.setItem(
            Constant.loginLocalStorageKeys.chatLogin,
            String(cms_response?.data?.access_token) ?? "OLD"
          );
          localStorage.setItem(
            Constant.loginLocalStorageKeys.chatLoginId,
            String(cms_response?.data?.id) ?? ""
          );
        }
      }

      localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true) //is loggedin
      localStorage.setItem(Constant.loginLocalStorageKeys.loginName, response.data.data.userName ?? "") //username
      localStorage.setItem(Constant.loginLocalStorageKeys.loginEmail, response.data.data.userName ?? "")
      localStorage.setItem(Constant.loginLocalStorageKeys.loginId, response.data.data.userId) //userid
       //for vernacular
       i18n.changeLanguage(response.data.data?.vernacularCode ?? "en")
       localStorage.setItem(Constant.loginLocalStorageKeys.vernacularCode, response.data.data.vernacularCode ?? "en")
      // history(`/${response.data.data.nextpage}`);
      localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${response.data.data.nextPage}`)
      window.location.href = response.data.data.nextpage
    } else {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginForAkhayatritiyaApiError(response));
    }
  } catch (error) {
    yield put(loginForAkhayatritiyaApiError(error));
  }
}

// login from loginfromuploadpartial

// function* adminloginfromuploadpartial({ payload: { user, history, from } }) {
//   try {
  
//     const response = yield call(UploadPartialAdminLogin, user);
//     if (response.data.status === "Success") {
//       if (response.data.data.mobileNumber) {
//         localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
//         yield put(loginfromuploadpartialSuccess(response));

//         if (response.data.data?.selectedversion == "V3") {
//           localStorage.setItem("isV3User", true)
//           const cms_response = yield call(CMS_Login_via, {
//             // userId: response.data.data.userId,
//             jwt: user.jwt? user.jwt : undefined,
            
//           });
//           if (cms_response.data) {
//             localStorage.setItem(
//               Constant.loginLocalStorageKeys.chatLogin,
//               String(cms_response?.data?.access_token) ?? "OLD"
//             );
//             localStorage.setItem(
//               Constant.loginLocalStorageKeys.chatLoginId,
//               String(cms_response?.data?.id) ?? ""
//             );
//           }
//         }

//         const token = response?.headers['authorization']; // Extract token

//         localStorage.setItem(Constant.loginLocalStorageKeys.accessToken, token);

//         localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true) //is loggedin
//         localStorage.setItem(Constant.loginLocalStorageKeys.loginName, response.data.data.userName ?? "") //username
//         localStorage.setItem(Constant.loginLocalStorageKeys.loginEmail, response.data.data.userName ?? "")
//         localStorage.setItem(Constant.loginLocalStorageKeys.loginId, response.data.data.userId) //userid
//         localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${response.data.data.nextPage}`)
//         localStorage.setItem(Constant.loginLocalStorageKeys.utmSource,response.data.data.utm_source ?? "")
//         localStorage.setItem(Constant.loginLocalStorageKeys.loginMobileNumber,response.data.data.utm_medium ?? "")
//         localStorage.setItem(Constant.loginLocalStorageKeys.loginMobileNumber,response.data.data.mobileNumber ?? "")

//          //for vernacular
//          i18n.changeLanguage(response.data.data?.vernacularCode ?? "en")
//          localStorage.setItem(Constant.loginLocalStorageKeys.vernacularCode, response.data.data.vernacularCode ?? "en")

//          console.log(response.data.data.nextPage,"response.data.data.nextPage");
         
//         history(`${response.data.data.nextPage}`);
//         if(response.data.data.nextPage =="/online-matrimony-site"){
//         history("/online-matrimony-site");
//         }
//       }
//       else {
//         yield put(loginfromuploadpartialSuccess(response));
//       }
//     } else {
//       localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
//       yield put(loginfromuploadpartialError(response));
//     }
//   } catch (error) {
//     yield put(loginfromuploadpartialError(error));
//   }
// }


// function* adminloginfromuploadpartial({ payload: { user, history, from } }) {
//   console.log(user, "user in adminloginfromuploadpartial");
  
//   try {
//     const response = yield call(UploadPartialAdminLogin, {

//       jwt: user.jwt? user.jwt : undefined,
//       utm_source: user.utm_source ? user.utm_source : undefined,
//       utm_medium: user.utm_medium ? user.utm_medium : undefined,
//       utm_campaign: user.utm_campaign ? user.utm_campaign : undefined,

//     });
//     if (response.data.status === "Success") {
//       alert('oj')

//       localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
//       localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${response.data.data.nextPage}`)
//       localStorage.setItem(Constant.loginLocalStorageKeys.loginMobileNumber,response.data.data.mobileNumber ?? "")

    
//       yield put(loginfromuploadpartialSuccess(response));

//       // history(`${response.data.data.nextPage}`);
//       history("/online-matrimony-site");


//     } else {
//       localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
//       yield put(loginfromuploadpartialError(response));
//     }
//   } catch (error) {
//     yield put(loginfromuploadpartialError(error));
//   }
// }

// get community detail
function* communitySiteDetailCall({ payload: { value, id, history } }) {
  try {
    const response = yield call(CommunitySiteData, {
      community: value,
    });
    if (response.data.status === "Success") {
      yield put(communitySiteDetailSuccess(response));
    } else {
      yield put(communitySiteDetailApiError(response));
    }
  } catch (error) {
    yield put(communitySiteDetailApiError(error));
  }
}

// site map detail
function* SiteMapDetailCall({ payload: { value } }) {
  try {
    const response = yield call(SiteMapData, value);
    if (response.data.status === "Success") {
      yield put(siteMapDetailSuccess(response));
    }
    else {
      yield put(siteMapDetailApiError(response));
    }
  } catch (error) {
    window.location.href = "/"
  }
}

// offline
function* offlineProfile({ payload: { user, history, from } }) {
  try {
    const response = yield call(offlineProfileLogin, {

      matching: user.matching ? user.matching : undefined,
      profiletoken: user.profiletoken ? user.profiletoken : undefined,
      jwt: user.jwt ? user.jwt : undefined,
      toProfileId: user.toProfileId ? user.toProfileId : undefined,
      offlinepack: user.offlinepack ? user?.offlinepack : undefined,
      mobilenumber: user.mobilenumber ? user?.mobilenumber : undefined,

    });
    if (response.data.status === "Success") {

      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginFromOfflineSuccess(response));

      if (usesLiteExperience(response.data.data?.selectedversion)) {
        localStorage.setItem("isV3User", true)
        const cms_response = yield call(CMS_Login_via, {
          userId: response.data.data.userId,
        });

        if (cms_response.data) {
          localStorage.setItem(
            Constant.loginLocalStorageKeys.chatLogin,
            String(cms_response?.data?.access_token) ?? "OLD"
          );
          localStorage.setItem(
            Constant.loginLocalStorageKeys.chatLoginId,
            String(cms_response?.data?.id) ?? ""
          );
        }
      }
      localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true) //is loggedin
      localStorage.setItem(Constant.loginLocalStorageKeys.loginName, response.data.data.userName ?? "") //username
      localStorage.setItem(Constant.loginLocalStorageKeys.loginEmail, response.data.data.userName ?? "")
      localStorage.setItem(Constant.loginLocalStorageKeys.loginId, response.data.data.userId) //userid
      localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${response.data.data.nextPage}`)
      localStorage.setItem(Constant.loginLocalStorageKeys.loginCheckForRquest,'loginCheckForReq')

       //for vernacular
       i18n.changeLanguage(response.data.data?.vernacularCode ?? "en")
       localStorage.setItem(Constant.loginLocalStorageKeys.vernacularCode, response.data.data.vernacularCode ?? "en")

      if (response.data.data?.nextPage.includes(RouteSegments.OFFLINE_PROFLIE) && user.toProfileId) {
        history(`${response.data.data.nextPage}`, {
          replace: true,
          state: {
            isFrom: "login",
            profile_id: user.toProfileId
          }
        })
      } else if (user.mobilenumber == "Y" && user.toProfileId) {
        history(`${response.data.data.nextPage}`, { replace: true, state: { isFrom: "login", profile_id: user.toProfileId, isPhonePopup: user.mobilenumber } });
      }

      
    } else {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginFromOfflineError(response));
    }
  } catch (error) {
    yield put(loginFromOfflineError(error));
  }
}

// view Profile
function* viewForProfileLogin({ payload: { user, history, from } }) {
  try {
    const response = yield call(viewProfileLogin, {

      profileid: user.profileid ? user?.profileid : undefined,
      action: user.action ? user?.action : undefined,

    });
    if (response.data.status === "Success") {

      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginForViewProfileSuccess(response));

       //for vernacular
       i18n.changeLanguage(response.data.data?.vernacularCode ?? "en")
       localStorage.setItem(Constant.loginLocalStorageKeys.vernacularCode, response.data.data.vernacularCode ?? "en")

       localStorage.setItem(Constant.loginLocalStorageKeys.isLoggedIn, true) //is loggedin
       localStorage.setItem(Constant.loginLocalStorageKeys.loginName, response.data.data.userName ?? "") //username
       localStorage.setItem(Constant.loginLocalStorageKeys.loginEmail, response.data.data.userName ?? "")
       localStorage.setItem(Constant.loginLocalStorageKeys.loginId, response.data.data.userId) //userid
       localStorage.setItem(Constant.loginLocalStorageKeys.loginCurrentPage, `${response.data.data.nextPage}`)
       localStorage.setItem(Constant.loginLocalStorageKeys.loginCheckForRquest,'loginCheckForReq')

      if (usesLiteExperience(response.data.data?.selectedversion)) {
        localStorage.setItem("isV3User", true)
        const cms_response = yield call(CMS_Login_via, {
          userId: response.data.data.userId,
        });

        if (cms_response.data) {
          localStorage.setItem(
            Constant.loginLocalStorageKeys.chatLogin,
            String(cms_response?.data?.access_token) ?? "OLD"
          );
          localStorage.setItem(
            Constant.loginLocalStorageKeys.chatLoginId,
            String(cms_response?.data?.id) ?? ""
          );
        }

        history(RouteSegments.MATCH_CONVERSATIONS_LITE, {
          state: {
            isFrom: "login",
            id: "KM" + user.toProfileId,
            isFromChat: false,
            from: "search"
          }
        })
      } else {
        history(RoutePaths.PROFILE, { state: { id: user.toProfileId } })
      }

    
    } else {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginForViewProfileError(response));
    }
  } catch (error) {
    yield put(loginForViewProfileError(error));
  }
}

// feedback resolved
function* FeedbackResolved({ payload: { srId, history, from } }) {
  try {
    const response = yield call(Feedback_Resolved_Form, {

      srno: srId ? srId : undefined,

    });
    if (response.data.status === "Success") {

      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      localStorage.setItem(Constant.loginLocalStorageKeys.srno, response.data.data.srno)

      yield put(loginFromFeedBackSuccess(response));

      history(RouteSegment.FEEDBACK_PAGE, { state: { srno: response.data.data.srno } })



    } else {
      localStorage.setItem(Constant.loginLocalStorageKeys.showLoader, true)
      yield put(loginFromFeedBackError(response));
    }
  } catch (error) {
    yield put(loginFromFeedBackError(error));
  }
}

function* communitySiteContentCall({ payload: { value, id, history } }) {
  try {
    const response = yield call(CommunitySiteContentApi, {
      community: value,
    });
    if (response.data.status === "Success") {
      yield put(communitySiteContentSuccess(response));
    } else {
      yield put(communitySiteContentError(response));
    }
  } catch (error) {
    yield put(communitySiteContentError(error));
  }
}


function* loginSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(CHANGE_MOBILE_NO, changeMobileNo)
  yield takeEvery(SEND_OTP, sendOTP);
  yield takeEvery(OTP_VALIDATION, OTPValidationCall);
  yield takeEvery(MOBILE_VERIFICATION, mobileVerificationCall);
  yield takeEvery(MOBILE_VERIFICATION_FRESH, mobileVerificationFreshCall);
  yield takeEvery(REQUEST_AGAIN, requestAgainCall)
  yield takeEvery(GET_BASIC_DATA, getBasicData)
  yield takeEvery(RESET_PASSWORD, resetPassword);
  yield takeEvery(MORE_LINK_CONTENT, moreLinkContent);

  yield takeEvery(LOGIN_FROM_ADMIN_USER, adminLoginUser);
  yield takeEvery(LOGIN_FROM_ADMIN_PARTIAL_USER, adminLoginPartialUser);
  yield takeEvery(LOGIN_FROM_EMAIL_USER, adminEmailUser);
  yield takeEvery(LOGIN_FROM_SMS_USER, adminSMSUser);
  yield takeEvery(LOGIN_FROM_OTP_USER, loginFromOtpUser);
  yield takeEvery(LOGIN_FOR_AKHAYATRITIYA, akhayatritiyaUser);
  yield takeEvery(LOGIN_FROM_OFFLINE, offlineProfile);
  yield takeEvery(LOGIN_FROM_OFFLINE, viewForProfileLogin);
  yield takeEvery(COMMUNITY_SITE_DETAIL, communitySiteDetailCall);
  yield takeEvery(SITE_MAP, SiteMapDetailCall);
  yield takeEvery(LOGIN_FROM_FEEDBACK, FeedbackResolved);
  yield takeEvery(COMMUNITYSITE_CONTENT,communitySiteContentCall);
  yield takeEvery(SUCCESS_STORY_FORM, successStoryLoginUser);

  // yield takeEvery(LOGIN_FROM_ADMIN_UPLOAD_PARTIAL_USER, adminloginfromuploadpartial);
}

export default loginSaga;
